import DCFPopup from '@dcf/js/components/dcf-popup.js';

export default class UNLPopup extends DCFPopup {
    constructor(popup, options = {}) {
        super(popup, options);
    }
}
